function sortedResultWords(words) {
  return (Array.isArray(words) ? words : []).map((word, index) => ({ word, index }))
    .sort((a, b) => (Number(b.word.score) || 0) - (Number(a.word.score) || 0) || a.index - b.index)
    .map(item => item.word);
}
module.exports = { sortedResultWords };
